module.exports = __webpack_public_path__ + "static/bg (8)-aca9c25597bd849cd66cc820f994fa8c.jpg";